import React from 'react';

import { IconHelp, IconUserCircle } from '@tabler/icons-react';
import { dashboardHref } from 'helpers/dashboardSession';
import { navTransactionLabel, useNavTransactions } from 'helpers/useNavTransactions';

import { MenuLinkItem } from '../components/MenuLinkItem';

interface MobileMenuAccountItemsProps {
  slug: string;
}

const isDashboardPath = (slug: string): boolean => {
  const normalizedSlug = slug.replace(/^\/+/, '');
  return normalizedSlug === 'dashboard' || normalizedSlug.startsWith('dashboard/');
};

export const MobileMenuAccountItemsV2: React.FC<MobileMenuAccountItemsProps> = ({ slug }) => {
  const transactions = useNavTransactions();

  return (
    <>
      <MenuLinkItem
        key="dashboard"
        href={dashboardHref('mobile_menu')}
        name="Dashboard"
        analyticsName="cosmos-mobile-nav-dashboard"
        isActive={isDashboardPath(slug)}
      />
      {transactions.map((transaction) => (
        <MenuLinkItem
          key={transaction.id}
          href={transaction.href}
          name={navTransactionLabel(transaction)}
          analyticsName={`cosmos-mobile-nav-${transaction.type}`}
          isActive={false}
        />
      ))}
      <MenuLinkItem
        key="account"
        href="/account"
        name="Account"
        icon={<IconUserCircle size={20} stroke={1.5} aria-hidden />}
        analyticsName=""
        isActive={slug === '/account'}
      />
      <MenuLinkItem
        href="https://help.opendoor.com"
        name="Help center"
        analyticsName="cosmos-mobile-nav-help-center"
        icon={<IconHelp size={20} stroke={1.5} aria-hidden />}
        isLast
      />
    </>
  );
};
